import { render, staticRenderFns } from "./VeHrKaohePerson.vue?vue&type=template&id=1e400e9a&scoped=true"
import script from "./VeHrKaohePerson.vue?vue&type=script&lang=js"
export * from "./VeHrKaohePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e400e9a",
  null
  
)

export default component.exports